/**
 * When a WhoSteps day starts: 06:00 local time, not midnight (Egor, 29 Sep; DECISIONS "New puzzle at 6am").
 * Before 06:00 the player is still on the previous day's puzzle, streak and Vault. Shared by the app and the
 * Worker (which opens a date's file once it is 06:00 on that date somewhere on Earth).
 */
export const DAY_START_HOUR = 6;

const iso = (d: Date): string => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** The player's puzzle date, YYYY-MM-DD: today from 06:00 local time, yesterday before that. Wall-clock based, so DST can't shift it. */
export function gameDate(now = new Date()): string {
  return iso(new Date(now.getFullYear(), now.getMonth(), now.getDate() - (now.getHours() < DAY_START_HOUR ? 1 : 0)));
}

/** Milliseconds from `now` until the puzzle dated `date` opens (06:00 local on that date). */
export function msUntilDay(date: string, now = new Date()): number {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(y!, m! - 1, d!, DAY_START_HOUR).getTime() - now.getTime();
}
